import React from "react"
import { Card, CardBody, Row, Col } from "reactstrap"
import PropTypes from "prop-types"

const LocationWorkingHoursCard = ({ hoursString, onEdit }) => {
    // Helper to parse the specific day's time from the big string
    const getTimeForDay = (day) => {
        if (!hoursString) return "OFF DAY"

        // Split string into lines
        const lines = hoursString.split("\n")
        // Find the line that starts with the day (e.g., "Monday:")
        const line = lines.find((l) => l.toLowerCase().startsWith(day.toLowerCase()))

        if (!line) return "OFF DAY"

        // Remove the day name and clean up
        let timePart = line.split(": ")[1] // get part after "Monday: "
        if (!timePart || timePart.trim() === "") return "OFF DAY"

        // Format "5 pm - 10 pm" into "5 PM | 10 PM" for the vertical layout
        return timePart.replace("-", "|").toUpperCase()
    }

    const days = [
        { label: "Mon", key: "Monday" },
        { label: "Tue", key: "Tuesday" },
        { label: "Wed", key: "Wednesday" },
        { label: "Thur", key: "Thursday" },
        { label: "Fri", key: "Friday" },
        { label: "Sat", key: "Saturday" },
        { label: "Sun", key: "Sunday" },
    ]

    return (
        <Card
            style={{
                backgroundColor: "#3C3C3C",
                borderRadius: "15px",
                border: "none",
                height: "100%", // Ensure equal height if side-by-side
                position: "relative"
            }}
        >
            <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 style={{ color: "#FFCA5C", fontWeight: "bold" }}>Working Hours</h5>
                    {/* {onEdit && (
                        <i
                            className="bx bx-edit"
                            style={{ color: "#fff", cursor: "pointer", fontSize: "18px" }}
                            onClick={onEdit}
                        ></i>
                    )} */}
                </div>

                <div className="d-flex justify-content-between text-center">
                    {days.map((day) => {
                        const timeRaw = getTimeForDay(day.key)
                        // Split "5 PM | 10 PM" into three parts for vertical stacking
                        const parts = timeRaw.includes("|")
                            ? timeRaw.split("|")
                            : [timeRaw]

                        return (
                            <div key={day.key} className="d-flex flex-column align-items-center">
                                <span className="text-white mb-3" style={{ fontSize: "14px" }}>
                                    {day.label}
                                </span>

                                {/* Time Display */}
                                <div style={{ color: "#FFCA5C", fontSize: "12px", fontWeight: "500", lineHeight: "1.5" }}>
                                    {parts.length > 1 ? (
                                        <>
                                            <div>{parts[0].trim()}</div>
                                            <div>|</div>
                                            <div>{parts[1].trim()}</div>
                                        </>
                                    ) : (
                                        <span>{parts[0]}</span>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </CardBody>
        </Card>
    )
}

LocationWorkingHoursCard.propTypes = {
    hoursString: PropTypes.string,
    onEdit: PropTypes.func
}

export default LocationWorkingHoursCard